// 公共变量
import GlobalVariable from '@/global/global-variable'
// 人员 上传模板
import ApiFileLocal from './api-file-local.js'

// 查询用户组
const searchUserGroupApi = GlobalVariable.BASE_PATH + "/rest/user/group/search";

// 添加用户组
const addUserGroupApi = GlobalVariable.BASE_PATH + "/rest/user/group/add";

// 修改用户组
const updateUserGroupApi = GlobalVariable.BASE_PATH + "/rest/user/group/update";

// 删除用户组
const deleteUserGroupApi = GlobalVariable.BASE_PATH + "/rest/user/group/delete";

// 查询用户
const searchUserApi = GlobalVariable.BASE_PATH + "/rest/user/base/search";

// 查询用户
const exportApi = GlobalVariable.BASE_PATH + "/rest/user/base/export";

// 查询标签用户
const findByTagIdApi = GlobalVariable.BASE_PATH + "/rest/user/base/findByTagId";

// 添加用户
const addUserApi = GlobalVariable.BASE_PATH + "/rest/user/base/add";

// 修改用户
const updateUserApi = GlobalVariable.BASE_PATH + "/rest/user/base/update";

// 删除用户
const deleteUserApi = GlobalVariable.BASE_PATH + "/rest/user/base/delete";

// 绑定
const bindingUserApi = GlobalVariable.BASE_PATH + "/rest/user/base/binding";
// 解除绑定
const unboundUserApi = GlobalVariable.BASE_PATH + "/rest/user/base/unbound";

// 上传解析
const uploadUrlApi = GlobalVariable.BASE_PATH + "/rest/user/base/upload";

// 查询用户心率
const findUserHearts = GlobalVariable.BASE_PATH + "/rest/user/base/findUserHearts";

// 修改关注级别
const updateFollowLevel = GlobalVariable.BASE_PATH + "/rest/user/base/updateFollowLevel";

// 同步用户
const syncBatchUser = GlobalVariable.BASE_PATH + "/rest/user/base/batchSync";

// 分组 统计
const searchNumber = GlobalVariable.BASE_PATH + "/rest/user/base/searchNumber";

// 一键呼叫
const callApi = GlobalVariable.BASE_PATH + "/rest/user/base/call";

export default {
    // 查询用户组
    searchUserGroupApi,
    // 添加用户组
    addUserGroupApi,
    // 修改用户组
    updateUserGroupApi,
    // 删除用户组
    deleteUserGroupApi,
    // 根据标签id查询人员信息
    findByTagIdApi,
    // 查询用户
    searchUserApi,
    // 导出用户
    exportApi,
    // 添加用户
    addUserApi,
    // 修改用户
    updateUserApi,
    // 删除用户
    deleteUserApi,
    // 绑定
    bindingUserApi,
    // 解除绑定
    unboundUserApi,
    // 上传解析
    uploadUrlApi,
    // 人员上传模板
    userUploadModel: ApiFileLocal.file_user_upload_model,
    // 查找用户心率
    findUserHearts,
    // 修改关注级别
    updateFollowLevel,
    syncBatchUser,
    // 分组 统计
    searchNumber,
    callApi
}



// WEBPACK FOOTER //
// ./src/request/api-user.js